<template>
  <badge-task-form :is-edit="false"></badge-task-form>
</template>
<script>
import BadgeTaskForm from './BadgeTaskForm';

export default {
  name: 'CreateBadgeTask',
  components: { BadgeTaskForm },
};
</script>
